import { render, staticRenderFns } from "./prizeDetails.vue?vue&type=template&id=3c7f112e&scoped=true"
import script from "./prizeDetails.vue?vue&type=script&lang=js"
export * from "./prizeDetails.vue?vue&type=script&lang=js"
import style0 from "./prizeDetails.vue?vue&type=style&index=0&id=3c7f112e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f112e",
  null
  
)

export default component.exports